import { render, staticRenderFns } from "./ViewDetail.vue?vue&type=template&id=0f0ded14&scoped=true"
import script from "./ViewDetail.vue?vue&type=script&lang=js"
export * from "./ViewDetail.vue?vue&type=script&lang=js"
import style0 from "./ViewDetail.vue?vue&type=style&index=0&id=0f0ded14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0ded14",
  null
  
)

export default component.exports